import _tableauNode from "./../../levels/common.blocks/tableau-node/tableau-node.react.js";

var TableauNode = _tableauNode.applyDecls();

export default TableauNode;